export enum userProperties {
  rallyId = 'Rally Id',
  client = 'Client',
  partner = 'Partner',
  sessionId = 'Session Id',
  subscriptionTierId = 'Subscription Tier Id',
  subscriptionTierName = 'Subscription Tier Name',
  product = 'Product',
  isUHC = 'Is UHC',
  serviceSector = 'Service Sector',
  lineOfBusiness = 'Line Of Business',
  HSID = 'HSID',
  EID = 'EID',
}

export interface AnalyticsUserProperties {
  [userProperties.rallyId]?: string;
  [userProperties.client]?: string;
  [userProperties.partner]?: string;
  [userProperties.sessionId]?: string;
  [userProperties.subscriptionTierId]?: string;
  [userProperties.subscriptionTierName]?: string;
  [userProperties.product]?: string;
  [userProperties.isUHC]?: boolean;
  [userProperties.serviceSector]?: string;
  [userProperties.lineOfBusiness]?: string;
  [userProperties.HSID]?: string;
  [userProperties.EID]?: string;
}

export enum EventType {
  CustomUserEvent = 'Custom User Event',
  ExternalNav = 'External Nav',
  PageNav = 'Page Nav',
  ModalNav = 'Modal Nav',
  FormError = 'Form Error',
  FormSubmit = 'Form Submit',
  CustomViewNameEvent = 'Custom View Name Event',
}

export enum PageTags {
  IsFilter = 'Is Filter',
  NewPageLoad = 'New Page Load',
  FilterName = 'Filter Name',
  FilterValues = 'Filter Value',
  IsSelectedTier = 'Is Selected Tier',
  AvailableTiers = 'Available Tiers',
  IsSubsidizedTier = 'Is Subsidized Tier',
  SelectedTiers = 'Selected Tiers',
  TriggerUIElementName = 'Trigger UI Element Name',
  TriggerUISection = 'Trigger UI Section',
  PageName = 'Page Name',
  PreviousPageName = 'Previous Page Name',
  TiggerPageName = 'Trigger Page Name',
}

export enum ExternalArgs {
  VendorName = 'Vendor Name',
}

export interface AnalyticsProps {
  adobePageName?: string;
}

export enum TriggerType {
  Auto = 'AUTO',
  BrowserNav = 'BROWSER_NAV',
  Click = 'CLICK',
  DirectNav = 'DIRECT_NAV',
  Keypress = 'KEYPRESS',
  PageLoad = 'PAGE_LOAD',
  Swipe = 'SWIPE',
}

/**
 * Enum for Top Pick Gym interaction types
 */
export enum TopPickInteractionType {
  CardClick = 'top_pick_card_click',
  PinClick = 'top_pick_pin_click',
  DetailsExpand = 'top_pick_details_expand',
  DetailsCollapse = 'top_pick_details_collapse',
  WebsiteLinkClick = 'top_pick_website_click',
}

/**
 * User context for Top Pick tracking
 */
export interface TopPickUserContext {
  eid?: string | null;
  memberId?: string | null;
  tierId?: string | null;
  sponsorId?: string | null;
}
